import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=47083a26&"
import script from "./TransferModal.vue?vue&type=script&lang=js&"
export * from "./TransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports